import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
/**
 * Whether the viewer holds the `org_settings_write` catalog permission — the
 * permissions-platform question behind surfaces that formerly gated on the
 * deprecated legacy admin role. Admins hold the grant through the seeded
 * admin role; custom-role settings writers pass too. The effective-permissions
 * endpoint is itself mode-aware (its `check()` returns the legacy-derived
 * answer for orgs not yet cut over), so this is safe on every rollout stage.
 * A failed or unavailable read fails closed. Gates that must not deny during
 * the initial fetch should consume `isLoading` and render their loading state.
 */
export function useCanManageOrgSettingsState(options) {
    const enabled = options?.enabled ?? true;
    const { permissions, isLoading } = useEffectivePermissions({
        reason: 'useCanManageOrgSettings',
        enabled,
    });
    // Disabling the fetch must also deny: a disabled React Query read can still
    // surface previously cached permissions.
    return { canManageOrgSettings: enabled && permissions.has('org_settings_write'), isLoading };
}
export const useCanManageOrgSettings = () => {
    return useCanManageOrgSettingsState().canManageOrgSettings;
};
//# sourceMappingURL=useCanManageOrgSettings.js.map